module.exports = __webpack_public_path__ + "static/media/nonord-c-17.9391488e.mp3";